module.exports = __webpack_public_path__ + "static/media/behance-original.80052054.svg";